// src/pages/tools/components/ToolDetailsTab.jsx
import React from 'react';
import {
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  Paper,
} from '@mui/material';

// Re-define or import if used elsewhere
const TOOL_TYPES = [
  { value: 'search', label: 'Search', description: 'Tools that search for information or data' },
  { value: 'api', label: 'API', description: 'Tools that interact with external APIs' },
  { value: 'calculation', label: 'Calculation', description: 'Tools that perform calculations or data processing' },
  { value: 'database', label: 'Database', description: 'Tools that interact with databases' },
  { value: 'utility', label: 'Utility', description: 'General utility tools for various tasks' },
  { value: 'custom', label: 'Custom', description: 'Custom tools that don\'t fit other categories' }
];

const ToolDetailsTab = ({ tool, handleChange, errors, isEditing }) => {
  return (
    <Paper elevation={2} sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Tool Name"
            name="name"
            value={tool.name || ''}
            onChange={handleChange}
            error={!!errors.name}
            helperText={errors.name || "User-friendly name for the tool."}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Tool Slug (ID)"
            name="slug"
            value={tool.slug || ''}
            onChange={handleChange}
            error={!!errors.slug}
            helperText={errors.slug || "Unique, URL-friendly identifier (e.g., my_search_tool). Auto-generated if empty."}
            disabled={isEditing}
            required={!isEditing}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Description"
            name="description"
            value={tool.description || ''}
            onChange={handleChange}
            multiline
            rows={3}
            error={!!errors.description}
            helperText={errors.description || "Explain what this tool does, its inputs, and outputs."}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth error={!!errors.tool_type} required>
            <InputLabel id="tool-type-label">Tool Type</InputLabel>
            <Select
              labelId="tool-type-label"
              name="tool_type"
              value={tool.tool_type || 'utility'}
              onChange={handleChange}
              label="Tool Type"
            >
              {TOOL_TYPES.map(type => (
                <MenuItem key={type.value} value={type.value}>
                  <Box>
                    <Typography>{type.label}</Typography>
                    <Typography variant="caption" color="text.secondary">{type.description}</Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
            {errors.tool_type && <Typography color="error" variant="caption" sx={{ml:2, mt:0.5}}>{errors.tool_type}</Typography>}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Default Parameters (JSON)"
            name="default_params"
            value={tool.default_params || '{}'}
            onChange={handleChange}
            multiline
            rows={3}
            error={!!errors.default_params}
            helperText={errors.default_params || "Optional default parameters in valid JSON format."}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={<Switch checked={tool.enabled === undefined ? true : tool.enabled} onChange={handleChange} name="enabled" />}
            label="Tool Enabled"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ToolDetailsTab;